module.exports = __webpack_public_path__ + "static/media/programLength.b1897798.svg";